import { Subject } from 'rxjs';

export class LoginFormConfig {
    eventSubject$: Subject<any> = new Subject<any>(); // triggered when login success
}
